import { Injectable } from '@angular/core';
import { Capacitor } from '@capacitor/core';
import { DbTableDefinition } from 'src/app/_services/persistence/db-persistence/db-table-definition';

@Injectable({
  providedIn: 'root',
})
export class PersonsDbTableDefinition extends DbTableDefinition {
  tableName = 'persons';
  tableStructure = `(id BIGINT(20) PRIMARY KEY null,
     label TEXT NOT NULL,
     name TEXT,
     lastname TEXT,
     fullname TEXT,
     email TEXT,
     primaryphonenumber TEXT,
     databag LONGTEXT
    );`;

  constructor() {
    super();
    this.updateStatements.set(36, [
      `CREATE TABLE IF NOT EXISTS ${this.tableName}${this.tableStructure}`,
    ]);

    // branchid/branchlabel were added after version 36 already shipped/ran on
    // devices - CREATE TABLE IF NOT EXISTS won't retroactively add columns to
    // an existing table, so this needs a real ALTER TABLE migration.
    if (Capacitor.getPlatform() === 'web') {
      this.alterStatements.push({ table: this.tableName, col: 'branchid', type: 'BIGINT(20)' });
      this.alterStatements.push({ table: this.tableName, col: 'branchlabel', type: 'TEXT' });
    } else {
      this.updateStatements.set(40, [
        `ALTER TABLE ${this.tableName} ADD COLUMN branchid BIGINT(20);`,
        `ALTER TABLE ${this.tableName} ADD COLUMN branchlabel TEXT;`,
      ]);
    }
  }
}
